





































import {Component, Prop, Vue} from 'vue-property-decorator';
import CTextField from '@/components/base/textField/CTextField.vue';
import {VDigitalTimePicker} from 'v-digital-time-picker';
@Component({
    components: {CTextField, VDigitalTimePicker},
})
export default class CDatepicker extends Vue {
    @Prop() value!: number | null;
    @Prop() activatorAttrs!: any;
    @Prop() pickerAttrs!: any;
    @Prop({default: false, type: Boolean}) nullable!: boolean;
    @Prop() label!: string;
    @Prop({type: Boolean, default: false}) withTime!: boolean;
    @Prop({type: Boolean, default: true}) showPrependIcon!: boolean;
    @Prop({type: Boolean, default: false}) readonly!: boolean;

    private menu: boolean = false;

    get dataPickerValue() {
        if (this.value !== null) return new Date(this.value).toISOString().slice(0, 10);
        return this.value;
    }
    set dataPickerValue(value: string | null) {
        let date = value === null ? value : Date.parse(value);
        if (date && this.withTime && this.timeValue) date = this.setTime(date, this.timeValue);
        this.$emit('input', date);
        if (!this.withTime) this.menu = false;
    }
    get textValue() {
        if (this.value !== null)
            return new Date(this.value).toLocaleString(this.$i18n.locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: this.withTime ? '2-digit' : undefined,
                minute: this.withTime ? '2-digit' : undefined,
            });
        return this.value;
    }
    get timeValue() {
        if (this.value) {
            let date = new Date(this.value),
                hours: any = date.getHours(),
                minutes: any = date.getMinutes();
            if (hours < 10) hours = '0' + hours;
            if (minutes < 10) minutes = '0' + minutes;
            return `${hours}:${minutes}`;
        }
        return '';
    }
    set timeValue(value: string) {
        // value format is 'hh:mm'
        if (this.value) {
            this.$emit('input', this.setTime(this.value, value));
        }
    }

    setTime(millsec: number, time: string): number {
        // time format is 'hh:mm'
        let hours = +time.substr(0, 2),
            minutes = +time.substr(3),
            date = new Date(millsec);
        date.setHours(hours);
        date.setMinutes(minutes);
        return Date.parse(date.toISOString());
    }

    onClear() {
        this.$emit('input', null);
    }
}
